// src/pages/passport/result/index.tsx  (또는 PaymentFailPage.tsx)
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const PaymentFailPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get('code');
  const msg = params.get('msg');

  return (
    <Wrap>
      <Card>
        <Title>결제에 실패했어요</Title>
        {code && (
          <StatusBox>
            <strong>코드:</strong> <span>{code}</span>
            {msg && (
              <Msg><strong>메시지:</strong> {msg}</Msg>
            )}
          </StatusBox>
        )}
        <Desc>
          결제 중 프로그램 에러가 발생하셨나요? <br />
          에러 메세지를 화면 캡쳐하여 아래 메일로 보내주시면 신속하게 처리해 드리겠습니다.
        </Desc>

        <InfoList>
          <li>
            <Label>업무지원 시간</Label>
            <span>08:30 ~ 17:30 (GMT+9)</span>
          </li>
          <li>
            <Label>담당자 이메일</Label>
            <a href="mailto:retailhelp@dhl.com">retailhelp@dhl.com</a>
          </li>
        </InfoList>

        <Actions>
          <Button type="button" onClick={() => navigate('/')}>
            홈으로 돌아가기
          </Button>
        </Actions>
      </Card>
    </Wrap>
  );
};

export default PaymentFailPage;

/* --- styles --- */
const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #fafafa;
`;

const Card = styled.div`
  width: 100%;
  max-width: 560px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 14px;
  padding: 28px 24px 24px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.04);
`;

const Title = styled.h1`
  margin: 0 0 12px 0;
  font-size: 22px;
  font-weight: 700;
`;

const Desc = styled.p`
  margin: 0 0 18px 0;
  line-height: 1.6;
  color: #444;
`;

const InfoList = styled.ul`
  list-style: none;
  margin: 0 0 20px 0;
  padding: 12px 14px;
  background: #f6f7f9;
  border: 1px solid #eef0f3;
  border-radius: 10px;

  li + li {
    margin-top: 8px;
  }

  a { color: #0073e6; text-decoration: none; }
  a:hover { text-decoration: underline; }
`;

const Label = styled.span`
  display: inline-block;
  min-width: 110px;
  font-weight: 600;
  color: #222;
`;

const Actions = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
`;

const Button = styled.button`
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
  font-weight: 600;

  &:hover { background: #f4f6f9; }
`;

const StatusBox = styled.div`
  background:#fff5f5;
  border:1px solid #ffd2d2;
  padding:12px 14px;
  border-radius:8px;
  margin-bottom:16px;
  font-size:14px;
  line-height:1.4;
  strong { color:#d40511; }
`;
const Msg = styled.p`
  margin:8px 0 0 0;
`;
